import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import Proposal from "../../../state/proposal/Proposal"
import { QuoteDto } from "../../../state/quote/Quote"

type OwnProps = {
    object: EventObjectDto
    quote: QuoteDto
    proposal: Proposal
}

const QuoteExportedToPipedriveEvent = (props: OwnProps) => {
    const Url = Integrations.getExternalOrderUrl(props.object)
    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {<FormattedMessage
                        id="quote.analytics.events.exported.pipedrive.text"
                        defaultMessage="Quote {identifier} was created from Pipedrive deal #{externalId}"
                        values={{
                            identifier: <strong>{props.quote.attributes.identifier}</strong>,
                            externalId:  props.object.attributes.externalId,
                        }}
                    />}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(INTEGRATION_KEY.PIPEDRIVE, 100, 50)}
                    </a>
                </div>
                {Url &&
                    <div className={""}>
                        <p className={"mb-0"}>
                            <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                                <FormattedMessage
                                    id="quote.analytics.events.exported.pipedrive.open"
                                    defaultMessage="Open deal in Pipedrive"
                                />
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}


export default QuoteExportedToPipedriveEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-exported-pipedrive.component.tsx